module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="column column-1 match-stat-column uppercase">\n	'+
((__t=( round_id ))==null?'':_.escape(__t))+
'\n</div>\n';
 if(is_bye) { 
__p+='\n    <div class="column full-width-column-10">BYE</div>\n';
 } else { 
__p+='\n<div class="column column-2 match-stat-column player-opponent-column">\n	';
 if( round_id === 'all' ) { 
__p+='\n		<figure>\n			<picture>\n				<img src="/assets/images/nrl-shield-logo-on-dark.svg" alt="" />\n			</picture>\n		</figure>\n	';
 } else { 
__p+='\n		<figure>\n			<picture>\n				<img src="'+
((__t=( squads_logos ))==null?'':_.escape(__t))+
''+
((__t=( opponent ))==null?'':_.escape(__t))+
'.png" alt="" />\n			</picture>\n		</figure>\n	';
 } 
__p+='\n</div>\n<div class="column column-3 match-stat-column">\n	';
 if( round_id === 'all' ) { 
__p+='\n		-\n	';
 } else { 
__p+='\n		('+
((__t=( venue ))==null?'':_.escape(__t))+
')\n	';
 } 
__p+='\n</div>\n<div class="column column-4 match-stat-column">\n	'+
((__t=( score ))==null?'':_.escape(__t))+
'\n</div>\n\n';
 _.each( headings, function(item, index) { 
__p+='\n	<div class="column column-'+
((__t=( index + 5 ))==null?'':_.escape(__t))+
' tooltip-team js-order-by pointer match-stat-column '+
((__t=( item.key === 'TOG' ? '' : '' ))==null?'':_.escape(__t))+
'"\n		 title="'+
((__t=( item.tooltip ))==null?'':_.escape(__t))+
'">\n		<div>\n			'+
((__t=( match_stats.match_stats[item.key] ))==null?'':_.escape(__t))+
'\n			<div class="score '+
((__t=( match_stats.match_points[item.key] > 0 ? 'positive' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( match_stats.match_points[item.key] < 0 ? 'negative' : '' ))==null?'':_.escape(__t))+
'">\n				('+
((__t=( match_stats.match_points[item.key] ))==null?'':_.escape(__t))+
')\n			</div>\n		</div>\n	</div>\n';
 }) 
__p+='\n';
 } 
__p+='';
}
return __p;
};
